export default {"src":"/_next/static/media/CA.c27ea403.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};